import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ContractObjectCreateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerCreateWorkOrderObjectGql } from '../../workOrderQueries';

const requestId = 'uerCreateWorkOrderObject';

export const useUerCreateWorkOrderObject = (workOrderId?: number, onSuccess?: (newObjectId?: number) => void) => {
    const dispatch = useDispatch();

    const [uerCreateWorkOrderObjectReset] = useResetStoreData({ requestId });

    const [
        uerCreateWorkOrderObjectData,
        uerCreateWorkOrderObjectStatus,
        uerCreateWorkOrderObjectError,
        uerCreateWorkOrderObjectRequest,
    ] = useRequest({
        requestId,
        query: uerCreateWorkOrderObjectGql,
        withEffect: false,
    });

    const uerCreateWorkOrderObjectRequestMakeRequest = useCallback(
        (input: ContractObjectCreateInput) => {
            dispatch(uerCreateWorkOrderObjectRequest({ workOrderId, input }));
        },
        [dispatch, uerCreateWorkOrderObjectRequest, workOrderId],
    );

    useEffect(() => {
        uerCreateWorkOrderObjectReset(undefined);
    }, [uerCreateWorkOrderObjectReset]);

    useEffect(() => {
        if (
            uerCreateWorkOrderObjectStatus === RequestStatus.SUCCESS &&
            uerCreateWorkOrderObjectData?.uerCreateWorkOrderObject?.data?.id
        ) {
            uerCreateWorkOrderObjectReset(undefined);
            onSuccess?.(uerCreateWorkOrderObjectData?.uerCreateWorkOrderObject?.data?.id);
        }
    }, [
        onSuccess,
        uerCreateWorkOrderObjectData?.uerCreateWorkOrderObject?.data?.id,
        uerCreateWorkOrderObjectReset,
        uerCreateWorkOrderObjectStatus,
    ]);

    return {
        uerCreateWorkOrderObjectData,
        uerCreateWorkOrderObjectStatus,
        uerCreateWorkOrderObjectError,
        uerCreateWorkOrderObjectRequestMakeRequest,
    };
};
